import React, { forwardRef } from "react";
import { ScrollView as NativeScrollView } from "react-native";
import styled from "styled-components/macro";

import { theme } from "../../../theme/restyle/theme";
import { RestyleScrollView, ScrollViewProps } from "./ScrollViewBase";

export type { ScrollViewProps } from "./ScrollViewBase";

const FocusVisibleScrollView = styled(RestyleScrollView)`
  &:focus-visible {
    outline: 2px solid ${theme.colors["outline-accent-blue"]};
    outline-offset: -2px;
  }
`;

export const ScrollView = forwardRef<
  React.ElementRef<typeof NativeScrollView>,
  ScrollViewProps
>(function ScrollView({ tabIndex = 0, ...props }, ref) {
  return <FocusVisibleScrollView ref={ref} tabIndex={tabIndex} {...props} />;
});
